import { v4 } from 'uuid';

import { OrganizationMember } from '@portal/common/types';

import * as types from './types';

type Action = {
    type: keyof typeof types;
    payload: { account: OrganizationMember };
};

type State = {
    token: null | string;
    expires: null | string;
    account: null | OrganizationMember;
    visitId: null | string;
    isImpersonated?: boolean;
};

const initialState: State = {
    token: null,
    expires: null,
    account: null,
    visitId: v4(),
    isImpersonated: false,
};

export default function (state: State = initialState, action: Action): State {
    switch (action.type) {
        case types.SESSION_SIGNED_IN:
        case types.SESSION_ACCOUNT_LOADED:
            return {
                ...state,
                visitId: v4(),
                ...action.payload,
            };

        case types.SESSION_ACCOUNT_UPDATED:
        case types.SESSION_ACCOUNT_PASSWORD_CHANGED:
            return {
                ...state,
                account: {
                    ...state.account,
                    ...action.payload,
                },
            };

        case types.SESSION_SIGNED_OUT:
        case types.SESSION_ERROR:
            return {
                ...initialState,
            };

        case types.SESSION_ACCOUNT_NOTIFICATION_SHOWN_CHANGED:
            return {
                ...state,
                account: {
                    ...state.account,
                    is_notification_shown: action.payload,
                },
            };

        default:
            return {
                ...state,
            };
    }
}
